<script lang="ts">
	//Services
	import { format } from '../../../../../services/i18n';
	import { localReq, postReq } from '../../../../../services/http';
	//Helpers
	import { get_local_ip, real_id } from '../../../../../helpers/interface_helpers';
	import { formatSnakeCaseToTitle } from '../../../../../helpers/utilities';
	import { tooltipText } from '../tooltip_text';
	//Stores
		import { getDeviceStatus, getDeviceSettings } from 'src/stores/device-runtime/status-selectors';
	//Design system components
	import { Button, Checkbox, Radio, toast, Tooltip } from '@Shelly/shelly-design-system';

	export let device;

	//TODO need to merge this component with the original btnType1L because difference is only one digit or think to create some wrapper which can split both requests..
	const id = real_id(device.id);

	$: settingsStore = getDeviceSettings(id);
	$: settings = $settingsStore;

	const btnTypes = [
		'momentary',
		'toggle',
		'edge',
		'detached',
		'action',
		'cycle',
		'momentary_on_release',
	];

	let reverse = $settingsStore[device.category + 's'][device.channel].btn2_reverse;
	let cacheReverse = reverse;
	let localIp = get_local_ip(id);

	//it's good index to be reactive but looks very glitchy and i prefer to be static just for 1l,
	//because it has 17 togglers and they are insane :D
	let index = btnTypes.indexOf($settingsStore[device.category + 's'][device.channel].btn2_type);
	let cacheIndex = index;
	let loading = false;

	const disabled =
		$settingsStore[device.category + 's'][device.channel].default_state === 'switch2';
	let toolTipMesage = (type: string) => {
		return {
			message: 'btn_type_unavailable_switch_info_toast',
			values: { pod_type: type },
		};
	};
	const toggleReverse = async () => {
		reverse = !reverse;
	};

	const setType = async (val) => {
		index = val;
	};

	const sentRequests = async () => {
		let setBtnType; //prepare variable for first promise
		let handleToggle; //prepare variable for second promise

		if (cacheIndex !== index) {
			//if setting was changed create request
			loading = true;
			if (localIp) {
				setBtnType = await localReq(
					device,
					`${localIp}/settings/${device.category}/${device.channel}`,
					'post',
					{
						btn2_type: btnTypes[index],
					},
				);
			} else {
				setBtnType = await postReq(`/device/generic_command`, {
					id: id,
					command: 'btn_type',
					payload: `{"btn":2,"type":"${btnTypes[index]}"}`,
				});
			}
		}

		if (cacheReverse !== reverse) {
			// again if there is changed setting create request
			loading = true;
			if (localIp) {
				handleToggle = await localReq(
					device,
					`${localIp}/settings/${device.category}/${device.channel}`,
					'post',
					{
						btn2_reverse: reverse ? 1 : 0,
					},
				);
			} else {
				handleToggle = await postReq(`/device/generic_command`, {
					id: id,
					command: 'btn_reverse',
					payload: `{"btn":2,"btn_reverse":${reverse ? 1 : 0}}`,
				});
			}
		}
		Promise.all([setBtnType, handleToggle]).then((res) => {
			//here based on changed settings we will have two or less requests. If no setting changed array's member will be undefined
			if (typeof res[0] !== 'undefined') {
				if (res[0].isok) {
					settings[device.category + 's'][device.channel].btn_type = btnTypes[index];
					devices_settings.update_devices_settings(id, settings);
					toast.open({
						type: 'success',
						title:
							$format('btn_type_scc_toast', {
								values: { type_value: formatSnakeCaseToTitle(btnTypes[index]) },
							}) ||
							`Button type was changed to ${formatSnakeCaseToTitle(btnTypes[index])}`,
					});
					cacheIndex = index;
				} else {
					toast.open({ type: 'danger', title: $format('error_global') });
					index = cacheIndex;
				}
			}
			if (typeof res[1] !== 'undefined') {
				if (res[1].isok) {
					settings[device.category + 's'][device.channel].btn_reverse = reverse;
					devices_settings.update_devices_settings(id, settings);
					toast.open({
						type: 'success',
						title: $format('swap_inputs_scc_toast') || `Inputs was swapped.`,
					});
					cacheReverse = reverse;
				} else {
					toast.open({ type: 'danger', title: $format('error_global') });
					reverse = cacheReverse;
				}
			}
			loading = false;
		});
	};
</script>

<Tooltip placement="top" title={tooltipText(toolTipMesage('switch 2'), disabled)}>
	<Radio
		size="m"
		{disabled}
		selected={index.toString()}
		value={'0' || '6'}
		on:click={() => setType(0)}
		id="radio-7vmlxly"
		>{$format('option_momentary_by_category', {
			values: { device_category: $format(`this_${device.category}`) },
		}) ||
			'Momentary - Set this {device.category} to be "Momentary" switch. Push-for "ON" or Push-for "OFF".'}</Radio
	>
</Tooltip>
{#if index === 0 || index === 6}
	<Radio
		size="m"
		selected={index.toString()}
		value={'6'}
		on:click={() => setType(index === 6 ? 0 : 6)}
		id="radio-bapct6l"
		>{$format('button_option_alert_1') ||
			"Don't activate if the button is long pushed. Notice: If short pushed, the relay will be switched only after the button is released."}</Radio
	>
{/if}
<Radio size="m" selected={index.toString()} value={'1'} on:click={() => setType(1)} id="radio-ew4xacv"
	>{$format('option_toggle_switch_by_category', {
		values: { device_category: $format(`this_${device.category}`) },
	}) ||
		'Toggle Switch - Set this {device.category} to be "Toggle" switch. Act as a flip switch with one state for "ON" and one state for "OFF".'}</Radio
>
<Tooltip placement="top" title={tooltipText(toolTipMesage('switch 2'), disabled)}>
	<Radio
		size="m"
		{disabled}
		selected={index.toString()}
		value={'2'}
		on:click={() => setType(2)}
		id="radio-bj9fvuo"
		>{$format('option_edge_switch_by_category', {
			values: { device_category: $format(`this_${device.category}`) },
		}) ||
			'Edge Switch - Set this {device.category} to be "Edge" switch. Changes state on every hit.'}</Radio
	>
</Tooltip>
<Radio size="m" selected={index.toString()} value={'3'} on:click={() => setType(3)} id="radio-1io4juk"
	>{$format('option_detached_by_category', {
		values: { device_category: $format(`this_${device.category}`) },
	}) ||
		'Detached Switch - Set this {device.category} to be in "Detached" switch mode - switch is separated from the relays.'}</Radio
>
<Radio size="m" selected={index.toString()} value={'4'} on:click={() => setType(4)} id="radio-q0cb1w9"
	>{$format('option_activation_switch') ||
		'Activation Switch - use it for motion sensor. Any input turns "ON" and resets Auto OFF timer.'}</Radio
>
<Checkbox size="m" checked={reverse} on:click={toggleReverse} id="checkbox-n7v10re"
	>{$format('option_reverse_inputs') ||
		'Reverse inputs - If you enable this option, the buttons On/Off position will be inverted.'}</Checkbox
>

<Button class="mt-s" {loading} size="m" width="full" on:click={sentRequests}
	>{$format('button_save')}</Button
>
